// [원본 복원] 전개발자 구조(16vw×25vh 고정 + 앞뒤 absolute) 그대로 —
// 고정 높이라 iOS에서도 행 붕괴가 없던 검증된 구조. 얹은 것 3가지뿐:
// ① 지문분석(type==="analysis") 뒤집힌 면 색만 ECHO 팔레트
// ② 모바일 사이즈만 축소(단어테스트 포함 — 색 톤은 원본 유지)
// ③ iOS 접두사(레이아웃 불변, 뒷면 비침만 차단)
const VocaStudyCard = ({ word, handleFlip, type }) => {
  const m = Math.min(window.innerWidth, window.screen.width) <= 768;
  return (
    <div
      style={{
        transform: word.isOpened ? "rotateY(180deg)" : "rotateY(0deg)",
        WebkitTransform: word.isOpened ? "rotateY(180deg)" : "rotateY(0deg)",
        transition: "transform 0.5s",
        // 데스크톱은 컨테이너 기준으로 5장이 정확히 들어가게. vw 로 하면
        // 컨테이너(약 1200px)보다 넓어져 좌우가 잘렸다 (5장×16vw=80vw).
        width: m ? "15.5vw" : "calc(20% - 8px)",
        minWidth: 0,
        minWidth: m ? "56px" : undefined,
        height: m ? "84px" : "25vh",
        transformStyle: "preserve-3d",
        WebkitTransformStyle: "preserve-3d",
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "100%",
          // ① 지문분석만 ECHO 뒤집힘 색 — 단어테스트는 원본 회색 톤 유지
          backgroundColor: "#FFFFFF",
          color: "#0E141B",
          backfaceVisibility: "hidden",
          WebkitBackfaceVisibility: "hidden",
          border: "1px solid #EBEBEB",
          boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.25)",
          borderRadius: "10px",
          padding: m ? "4px" : "10px",
          boxSizing: "border-box",
          fontSize: m ? "11px" : "24px",
          overflow: "hidden",
          wordWrap: "break-word",
          wordBreak: "break-word", // 긴 단어가 있을 경우 강제 줄바꿈
          overflowWrap: "break-word", // 대체 속성 (현대 브라우저 호환성)
          whiteSpace: "normal", // 줄바꿈 허용
          textAlign: "center",
        }}
        onClick={() => handleFlip(word)}
      >
        {word.eng}
      </div>
      <div
        style={{
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "100%",
          backgroundColor:
            type === "analysis" ? "rgba(45, 240, 52, 0.1)" : "#EBEBEB",
          // ① 지문분석만 ECHO 뒤집힘 색 — 단어테스트는 원본 회색 톤 유지
          backgroundColor: type === "analysis" ? "#E5FBF8" : "#EBEBEB",
          color: type === "analysis" ? "#00A396" : "inherit",
          backfaceVisibility: "hidden",
          WebkitBackfaceVisibility: "hidden",
          border: "1px solid #EBEBEB",
          boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.25)",
          borderRadius: "10px",
          padding: m ? "4px" : "10px",
          boxSizing: "border-box",
          // 뜻이 길면 글자를 짓누르지 않고 **카드 안에서 스크롤한다.** 예전에는
          // 9px 까지 줄이고 넘치는 것을 잘라 냈는데(overflow:hidden), 뜻이 여러 개인
          // 단어는 뒷면이 읽을 수 없거나 잘린 채로 보였다. 카드 크기는 그대로라
          // 화면 배치는 안 흔들린다.
          fontSize: m ? "12px" : "20px",
          fontWeight: "bold",
          lineHeight: 1.4,
          transform: "rotateY(180deg)",
          WebkitTransform: "rotateY(180deg)", // 뒤쪽 회전
          textAlign: "center",
        }}
        onClick={() => handleFlip(word)}
      >
        <div
          style={{
            // 짧으면 가운데, 길면 위에서부터 스크롤. maxHeight 를 안 걸면
            // 부모 flex 가운데 정렬이 넘친 글을 위아래로 밀어 잘라 버린다.
            maxHeight: "100%",
            overflowY: "auto",
            WebkitOverflowScrolling: "touch",
            wordBreak: "break-word",
            overflowWrap: "break-word",
            whiteSpace: "normal",
          }}
        >
          {word.kor}
        </div>
      </div>
    </div>
  );
};

export default VocaStudyCard;
